import { otto } from "@gr-exports/async/nexus";
import { PREFIX } from "../lib/tracking/index.js";
const tracking = otto[PREFIX] ?? {};
const onInit = tracking.onInit;
const lockInit = tracking.lockInit;
const unlockInit = tracking.unlockInit;
export {
  PREFIX,
  lockInit,
  onInit,
  tracking,
  unlockInit
};
